import React from 'react';
import { Order } from '../../models/APIModels';
import Moment from 'moment';
import { toMoney } from '../../utilities/MoneyConversion';
import { getOrderTypeLabel } from '../../utilities/OrderHelpers';

interface PastOrderCardProps {
  order: Order;
  onViewDetails: (e?: React.MouseEvent) => void;
}

export const PastOrderCard: React.FC<PastOrderCardProps> = ({
  order,
  onViewDetails,
}) => {
  const orderTypeLabel = getOrderTypeLabel(order);
  
  const getTotalPaid = (): number => {
    if (order.payments && order.payments.length > 0) {
      const succeededPayments = order.payments.filter(p => p.succeeded);
      if (succeededPayments.length > 0) {
        return succeededPayments.reduce((sum, payment) => sum + payment.amount, 0);
      }
    }
    
    if (order.totalInitialCost) {
      return order.totalInitialCost;
    }
    
    return order.initialCost || 0;
  };

  const getCompletionDate = (): number => {
    if (order.statuses && order.statuses.length > 0) {
      const sortedStatuses = [...order.statuses].sort((a, b) => b.updatedAt - a.updatedAt);
      return sortedStatuses[0].updatedAt;
    }
    return order.updatedAt;
  };

  const totalPaid = getTotalPaid();
  const completionDate = getCompletionDate();

  return (
    <div className="past-order-card" onClick={onViewDetails}>
      <div className="past-order-info">
        <div className="past-order-header">
          <span className="past-order-type">{orderTypeLabel} Order</span>
          <span className="past-order-id">#{order.id}</span>
        </div>
        <div className="past-order-details">
          <div className="past-order-detail-item">
            <span className="past-order-label">Total Paid:</span>
            <span className="past-order-value">{toMoney(totalPaid)}</span>
          </div>
          <div className="past-order-detail-item">
            <span className="past-order-label">Completed:</span>
            <span className="past-order-value">
              {Moment(completionDate).format('MMM D, YYYY')}
            </span>
          </div>
        </div>
      </div>
      <div className="past-order-action">
        <span className="past-order-link">View Details →</span>
      </div>
    </div>
  );
};

